import {
    type GetAnnouncementByIdResponseType,
    type GetAnnouncementByIdRequestType
} from "./type";
import {
    request
} from "../request";

const GetAnnouncementById = async (params: GetAnnouncementByIdRequestType): Promise<GetAnnouncementByIdResponseType> => {
    return await request<GetAnnouncementByIdResponseType>("/announcement/getAnnouncementById", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default GetAnnouncementById;
